var exports = {
  "TT": "ProfileCardUserInfo.module__userInfoContainer___c0VHMj",
  "S7": "ProfileCardUserInfo.module__nameRow___c0VHMj",
  "oo": "ProfileCardUserInfo.module__nameButton___c0VHMj",
  "uV": "ProfileCardUserInfo.module__nameButtonClickable___c0VHMj",
  "fC": "ProfileCardUserInfo.module__badgeContainer___c0VHMj",
  "NW": "ProfileCardUserInfo.module__userTagWrapper___c0VHMj",
  "bF": "ProfileCardUserInfo.module__belowName___c0VHMj",
  "Hq": "ProfileCardUserInfo.module__actionsContainer___c0VHMj",
  "Fj": "ProfileCardUserInfo.module__usernameRow___c0VHMj",
  "xO": "ProfileCardUserInfo.module__usernameButton___c0VHMj",
  "hI": "ProfileCardUserInfo.module__pronouns___c0VHMj",
  "sM": "ProfileCardUserInfo.module__srOnly___c0VHMj",
};

module.exports = exports;
